import React, { useState } from "react";
import axios from "axios";
import { ArrowRight, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterForm({ variant = "light", source = "home" }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("loading");
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, {
        email: email.trim(),
        source,
      });
      setStatus("ok");
      setMessage(
        res.data.already_subscribed
          ? "You're already in. Stay thirsty."
          : "You're in. Inbox inbound.",
      );
      setEmail("");
    } catch (err) {
      setStatus("err");
      setMessage(
        err?.response?.data?.detail?.[0]?.msg ||
          "Something broke. Try again.",
      );
    }
  };

  const isDark = variant === "dark";

  return (
    <form
      data-testid="newsletter-form"
      onSubmit={submit}
      className="flex w-full flex-col gap-3"
    >
      <div
        className={`flex items-stretch overflow-hidden rounded-full border-2 ${
          isDark ? "border-cream bg-cobalt" : "border-jet bg-cream"
        }`}
        style={{ boxShadow: isDark ? "5px 5px 0 #F5EDDC" : "5px 5px 0 #0B0B0F" }}
      >
        <input
          data-testid="newsletter-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className={`flex-1 bg-transparent px-6 py-3.5 font-sans font-semibold text-base outline-none placeholder:opacity-60 ${
            isDark ? "text-cream placeholder:text-cream" : "text-jet placeholder:text-jet"
          }`}
        />
        <button
          data-testid="newsletter-submit-btn"
          type="submit"
          disabled={status === "loading"}
          className={`flex items-center gap-2 px-6 font-sans font-extrabold uppercase tracking-[0.08em] text-sm transition ${
            isDark
              ? "bg-cream text-jet hover:bg-butter"
              : "bg-cobalt text-cream hover:bg-orange"
          } disabled:opacity-50`}
        >
          {status === "loading" ? "Sending…" : "Drop me in"}
          <ArrowRight size={16} />
        </button>
      </div>
      {status !== "idle" && message && (
        <div
          data-testid="newsletter-status-msg"
          className={`flex items-center gap-2 text-sm font-bold ${
            status === "err"
              ? "text-pink"
              : isDark
                ? "text-butter"
                : "text-cobalt"
          }`}
        >
          {status === "ok" && <CheckCircle2 size={16} />}
          {message}
        </div>
      )}
    </form>
  );
}
